"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CoreEst_component_1 = require("../CoreEst/CoreEst.component");
exports.BeonairCoreEstPackage = function (props) {
    var isDependent = props.isDependent;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(CoreEst_component_1.BeonairCoreEst, { isDependent: isDependent })));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29yZUVzdFBhY2thZ2UuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYmVvbmFpci9Db3JlRXN0UGFja2FnZS9Db3JlRXN0UGFja2FnZS5jb21wb25lbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLGtFQUEyRDtBQUU5QyxRQUFBLHFCQUFxQixHQUFHLFVBQUMsS0FBSztJQUNoQyxJQUFBLCtCQUFXLENBQVM7SUFDM0IsT0FBTyxDQUNIO1FBQ0ksOEJBQUMsa0NBQWMsSUFBQyxXQUFXLEVBQUUsV0FBVyxHQUFJLENBQzFDLENBQ1QsQ0FBQTtBQUNMLENBQUMsQ0FBQSJ9